import React from 'react';

//components
import BasicButton from '../../../global/buttons/BasicButton';

//interfaces
import { IAddExtraConditionButton  } from '../../interfaces/IConditionalLogicPanel';



const AddExtraConditionButton = ({ content, ariaLabel, onAddConditionClick }: IAddExtraConditionButton ) => {
    
    if (!onAddConditionClick) {
        return <></>
    }
    
    return (
        <BasicButton 
            className='add-condition-button' 
            content={content} 
            ariaLabel={ariaLabel} 
            onButtonClick={onAddConditionClick} 
        />
    );
};

export default AddExtraConditionButton 